<script setup lang="ts">
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  title: string
  description: string
  shape: {
    variant: ShapeVariant
    color: 'grey' | 'peach' | 'green'
  }
}>()
</script>

<template>
  <li class="flex gap-l items-center">
    <Shape
      :variant="shape.variant" class="text-polar-500 w-28 min-w-28" :icon="faCheck" :class="{
        'fill-carbon-50': shape.color === 'grey',
        'fill-red-50': shape.color === 'peach',
        'fill-moss-100': shape.color === 'green',
      }"
    />
    <div class="flex flex-col gap-2xs">
      <h5 class="font-semibold" v-text="title" />
      <p class="text-base" v-text="description" />
    </div>
  </li>
</template>
